/**
 * @name setHeight
 */

class setHeight {
    constructor() {
        this.flag = document.querySelector('[data-get-height]');
        if (!this.flag) return;

        this.dom = this.flag;
        this.atter = document.querySelectorAll('[data-atter-height]');
        this.body = document.querySelector('body');

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.updateHeight();

        const resizeObserver = new ResizeObserver(() => {
            this.updateHeight();
        });

        resizeObserver.observe(this.body);
    }

    /**
     * @name updateHeight
     */
    updateHeight() {
        const height = this.dom.offsetHeight;
        this.atter.forEach(element => {
            element.style.setProperty('--h', `${height}px`);
        });
    }
}

export default setHeight;